import httpProvider from 'Providers/http.js';

export default {
    getUnverifiedContactsByOrganization(organizationId) {
        return new Promise((resolve, reject) => {
            httpProvider.get(`/sigur/user/contacts/unverified?organizationId=${organizationId}`).then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    getContactsByOrganization(organizationId, propertyId = null, sipServerId = null) {
        const params = { organizationId: organizationId };
        
        if (propertyId) {
            params.propertyId = propertyId;
        }

        if (sipServerId) {
            params.sipServerId = sipServerId;
        }
        
        return new Promise((resolve, reject) => {
            httpProvider.get('/sigur/user/contacts?' + new URLSearchParams(params).toString())
            .then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    getContacts(filters = {}) {
        return new Promise((resolve, reject) => {
            httpProvider.get('/sigur/user/contacts?' + new URLSearchParams(filters).toString())
            .then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    updateContact(data) {
        return new Promise((resolve, reject) => {
            httpProvider.put('/sigur/user/contact/update/' + data.id, data)
            .then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    verifyContacts(data) {
        return new Promise((resolve, reject) => {
            httpProvider.put('/sigur/user/verify', data)
            .then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    removeContacts(data) {
        return new Promise((resolve, reject) => {
            httpProvider.delete('/sigur/user/contact/delete/' + data).then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch(error => {
                reject(error);
            })
        });
    },
    setContactAccessRules(data) {
        return new Promise((resolve, reject) => {
            httpProvider.put('/sigur/user/contact/access-rules/' + data.contactId, data)
            .then(response => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                reject(error);
            })
        })
    }
    
}